const titleHeaderEvent = {
  text: 'Dia'
};

export default titleHeaderEvent;
